/*
 * File: FancySelect.tsx
 * Project: rosita
 * -----
 * Last Modified: 06 Mar 2022 1:39:19 pm
 * -----
 * Copyright (c) 2022 Elegant Software Solutions All rights reserved.
 */

/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import { Select, SelectProps } from 'antd';
import { DefaultOptionType } from 'antd/lib/select';
import { BaseSelectRef } from 'rc-select';
import { FC, useEffect, useRef, useState } from 'react';
import { InlineStylesModel } from '../../../models/InlineStylesModel';

interface FancySelectProps extends SelectProps {
  width?: number;
}

const styles: InlineStylesModel = {
  form: {
    position: 'relative'
  },
  borderAnimation: {
    transition: 'all 0.3s ease'
  },
  input: {
    width: '100%',
    minWidth: 150,
    display: 'block'
  },
  labelUnfocused: {
    position: 'absolute',
    color: 'rgba(0,0,0,0.50)',
    top: 5,
    left: 10,
    transition: 'all 0.3s ease'
  },
  labelFocused: {
    position: 'absolute',
    paddingLeft: 5,
    paddingRight: 5,
    top: -15,
    left: 8,
    transition: 'all 0.3s ease',
    borderRadius: 5,
    background: 'linear-gradient(0deg, rgba(255,255,255,0) 0%, rgba(255,255,255,1) 30%, rgba(255,255,255,1) 100%)'
  }
};

export const FancySelect: FC<FancySelectProps> = ({ width, value, placeholder, defaultValue, ...rest }: FancySelectProps) => {
  const [isLabelTop, _setIsLabelTop] = useState(false);
  const [isOpen, _setIsOpen] = useState(false);

  const inputRef = useRef<BaseSelectRef>(null);

  const inputWidth = width ? { ...styles.input, width } : styles.input;

  const handleFocus = (): void => {
    _setIsLabelTop(true);
    _setIsOpen(true);
  };

  const onLabelClick = (): void => {
    if (!isLabelTop) {
      _setIsLabelTop(true);
      _setIsOpen(true);
      inputRef.current?.focus();
    }
  };

  const handleBlur = (): void => {
    if (!value || (Array.isArray(value) && !value.length)) {
      _setIsLabelTop(false);
    }
    _setIsOpen(false);
  };

  // NOT SURE IF WE NEED THIS
  const handleFilterOption = (input: string, option: DefaultOptionType | undefined): boolean => {
    if (!!option && typeof option.label === 'string')
      return (
        !!option &&
        !!option.value &&
        typeof option.value === 'string' &&
        typeof option.label === 'string' &&
        (option.value.toLowerCase().indexOf(input.toLowerCase()) >= 0 || option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0)
      );

    return !!option && !!option.value && typeof option.value === 'string' && option.value.toLowerCase().indexOf(input.toLowerCase()) >= 0;
  };

  // Sets placeHolder label to top for selectors with a defaultValue
  useEffect(() => {
    if (value && value.length && !isLabelTop) {
      _setIsLabelTop(true);
    }
  }, [isLabelTop, value]);

  return (
    <div style={isLabelTop ? { ...styles.form, ...styles.borderAnimation } : styles.form}>
      <Select {...rest} value={value} ref={inputRef} style={inputWidth} onFocus={handleFocus} onBlur={handleBlur} filterOption={handleFilterOption} open={isOpen} allowClear />
      <label style={isLabelTop ? styles.labelFocused : styles.labelUnfocused} onClick={onLabelClick}>
        <span>{placeholder}</span>
      </label>
    </div>
  );
};
